module.exports = __webpack_public_path__ + "13722bffcdd726c6a3db261c3fd5662a.svg";